<template>
<v-snackbar v-model="snackbar" top color="red" :timeout="6000">
  <span class="error-message">{{errorMessage}}</span>
  <v-btn text class="text-none" id="snackbar-button" @click="snackbar=false">Close</v-btn>
</v-snackbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    snackbar: {
      get() {
        return this.errorSnackbar;
      },
      set(newValue) {
        this.$emit("update:errorSnackbar", newValue);
      }
    }
  },
  props: ["errorMessage", "errorSnackbar"]
};
</script>

<style>
#snackbar-button {
  font: 16px/19px "Montserrat";
}

.error-message {
  font: 16px/19px "Montserrat";
}
</style>
